import React from 'react'
import '../styles/starproduct.css'

const StarProduct = (props) => {
    console.log("star products",props.starproduct)
    return (
        <>
            <div className="starProduct">
                <div><a href={props.starproduct[0].url}><img src={props.starproduct[0].image} alt="1st Product"></img></a></div>
                <div>
                <a href={props.starproduct[1].url}><img src={props.starproduct[1].image} alt="2nd Product"></img></a>  
                <a href={props.starproduct[2].url}><img src={props.starproduct[2].image} alt="3rd Product"></img></a>
                <a href={props.starproduct[3].url}><img src={props.starproduct[3].image} alt="4th Product"></img></a>
                </div>

                {/* <div>
                    {
                        props.starproduct.map((item,index)=>{
                            return(
                            <div>
                                <a href={item.url}><img src={item.image} alt={`product no ${index} `}></img></a>
                            </div>
                            )
                        })
                    }
                </div> */}

            </div>
        </>
    )
}

export default StarProduct
